// extracted by mini-css-extract-plugin
export default {"element":"_1YChF"};